import { render, staticRenderFns } from "./SalesTracking.vue?vue&type=template&id=9db114c4&"
import script from "./SalesTracking.vue?vue&type=script&lang=js&"
export * from "./SalesTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports